import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { BottomSheetProps } from '@shared/ui/molecules';
import { CrossIcon } from '@shared/assets/icons';
import { Link, Text } from '@shared/ui/atoms';
type ModalContentProps = Pick<BottomSheetProps, 'onClose'>;
const ModalContent: FC<ModalContentProps> = ({
  onClose
}) => <>
    <HeaderWrapper>
      <Text family="MTSWide" size={{
      desktop: 'h6',
      mobile: 'pL'
    }} weight="bold" color="primary">
        Правовая документация
      </Text>
      <IconButtonWrapper type="button" onClick={onClose}>
        <CrossIcon />
      </IconButtonWrapper>
    </HeaderWrapper>
    <ContentWrapper>
      <Link href="https://staticpayment.ssl.mts.ru/upload/%D0%9F%D1%83%D0%B1%D0%BB%D0%B8%D1%87%D0%BD%D0%B0%D1%8F_%D0%BE%D1%84%D0%B5%D1%80%D1%82%D0%B0_2026.pdf">
        <Text family="MTSCompact" size="pL" weight="medium" color="primary">
          Публичная оферта
        </Text>
      </Link>
      <Link href="https://staticpayment.ssl.mts.ru/upload/Oferta_cyber1.pdf">
        <Text family="MTSCompact" size="pL" weight="medium" color="primary">
          Оферта
        </Text>
      </Link>
      <Link href="https://staticpayment.ssl.mts.ru/upload/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5.pdf">
        <Text family="MTSCompact" size="pL" weight="medium" color="primary">
          Согласие
        </Text>
      </Link>
    </ContentWrapper>
  </>;
export default ModalContent;
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1qr5wit",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "iw6omk3",
  propsAsIs: false,
  vars: {
    "iw6omk3-0": [_exp()]
  }
}));
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "cb96gec",
  propsAsIs: false
});

require("./ModalContent.linaria.module.css!=!../../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ModalContent.tsx");